export function ConvertNull(str) {
  if (str == "null" || str == "undefined") return null;
  else return str;
}
